(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  class SearchResultsLoader extends HTMLElement {
    infiniteScrollController = null;
    loadMorePromise = null;
    listMutationObserver = null;
    restartFrame = 0;
    filterUpdatePending = false;

    connectedCallback() {
      this.setupLoadMore();
      this.setupInfiniteScroll();
      this.addEventListener('orr:product-list:restored', this.restartInfiniteScroll);
      document.addEventListener('filter:update', this.handleFilterUpdate);
      this.listMutationObserver = new MutationObserver(this.handleListMutation);
      this.listMutationObserver.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.infiniteScrollObserver?.disconnect();
      this.infiniteScrollController?.destroy();
      this.infiniteScrollController = null;
      this.listMutationObserver?.disconnect();
      this.listMutationObserver = null;
      cancelAnimationFrame(this.restartFrame);
      this.restartFrame = 0;
      clearTimeout(this.resizeTimer);
      window.removeEventListener('resize', this.handleInfiniteScrollResize);
      document.removeEventListener('filter:update', this.handleFilterUpdate);
      this.removeEventListener('click', this.handleLoadMoreClick);
      this.removeEventListener('orr:product-list:restored', this.restartInfiniteScroll);
    }

    setupLoadMore() {
      this.addEventListener('click', this.handleLoadMoreClick);
    }

    handleLoadMoreClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const loadMoreBtn = event.target.closest('#load-more-btn');
      if (!loadMoreBtn || !this.contains(loadMoreBtn)) return;
      event.preventDefault();
      this.loadNextPage();
    };

    handleListMutation = (mutations) => {
      const loadMoreTargetChanged = mutations.some((mutation) =>
        [...mutation.addedNodes, ...mutation.removedNodes].some(
          (node) =>
            node instanceof Element &&
            (node.matches('.orr-load-more-container') || node.querySelector('.orr-load-more-container'))
        )
      );
      const filteredGridChanged =
        this.filterUpdatePending &&
        mutations.some(
          (mutation) =>
            mutation.type === 'childList' &&
            mutation.target instanceof Element &&
            (mutation.target.matches('#product-grid') || mutation.target.closest('#product-grid'))
        );
      if (!loadMoreTargetChanged && !filteredGridChanged) return;
      this.filterUpdatePending = false;
      if (this.restartFrame) return;

      this.restartFrame = requestAnimationFrame(() => {
        this.restartFrame = 0;
        this.restartInfiniteScroll();
      });
    };

    handleFilterUpdate = (event) => {
      if (event.target instanceof Node && this.contains(event.target)) {
        this.filterUpdatePending = true;
      }
    };

    loadNextPage = () => {
      if (this.loadMorePromise) return this.loadMorePromise;

      const productGrid = this.querySelector('#product-grid');
      const loadMoreBtn = this.querySelector('#load-more-btn');
      const nextUrl = productGrid?.getAttribute('data-next-url');
      if (!productGrid || !loadMoreBtn || !nextUrl) return Promise.resolve('done');

      loadMoreBtn.classList.add('loading');

      this.loadMorePromise = fetch(nextUrl)
        .then((response) => {
          if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
          return response.text();
        })
        .then((responseText) => {
          const parser = new DOMParser();
          const html = parser.parseFromString(responseText, 'text/html');
          const newGrid = html.querySelector('#product-grid');
          if (!newGrid) return 'error';

          const newProducts = newGrid.querySelectorAll('.product-card-wrapper');
          const newNextUrl = newGrid.getAttribute('data-next-url');
          if (newProducts.length === 0 && newNextUrl) return 'error';

          newProducts.forEach((item) => {
            productGrid.appendChild(item);
          });

          if (newNextUrl) {
            productGrid.setAttribute('data-next-url', newNextUrl);
          } else {
            productGrid.removeAttribute('data-next-url');
            loadMoreBtn.style.display = 'none';
          }

          history.replaceState(
            window.orrProductListHistory?.mergeHistoryState() ?? history.state,
            '',
            nextUrl
          );

          return newNextUrl ? 'loaded' : 'done';
        })
        .catch((error) => {
          console.error('Error loading more products:', error);
          return 'error';
        })
        .finally(() => {
          loadMoreBtn.classList.remove('loading');
          this.loadMorePromise = null;
        });

      return this.loadMorePromise;
    };

    setupInfiniteScroll() {
      this.updateInfiniteScroll();
      window.addEventListener('resize', this.handleInfiniteScrollResize);
    }

    updateInfiniteScroll = () => {
      const loadMoreContainer = this.querySelector('.orr-load-more-container');

      if (window.innerWidth <= 1023 && loadMoreContainer) {
        if (window.orrInfiniteScrollTrigger) {
          this.infiniteScrollObserver?.disconnect();
          this.infiniteScrollObserver = null;

          if (this.infiniteScrollController) {
            this.infiniteScrollController.refresh();
          } else {
            this.infiniteScrollController = window.orrInfiniteScrollTrigger.create({
              sentinel: loadMoreContainer,
              isEnabled: () => this.isConnected && window.innerWidth <= 1023,
              canLoad: () => {
                const productGrid = this.querySelector('#product-grid');
                return Boolean(
                  !window.orrProductListHistory?.isRestoring &&
                    !this.loadMorePromise &&
                    productGrid?.getAttribute('data-next-url')
                );
              },
              load: this.loadNextPage,
            });
          }
          return;
        }

        if (!this.infiniteScrollObserver) {
          this.infiniteScrollObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  if (window.orrProductListHistory?.isRestoring) return;

                  const productGrid = this.querySelector('#product-grid');
                  const loadMoreBtn = this.querySelector('#load-more-btn');
                  const nextUrl = productGrid?.getAttribute('data-next-url');
                  if (nextUrl && loadMoreBtn && !loadMoreBtn.classList.contains('loading')) {
                    this.loadNextPage();
                  }
                }
              });
            },
            {
              rootMargin: '0px 0px 400px 0px',
              threshold: 0.1,
            }
          );
          this.infiniteScrollObserver.observe(loadMoreContainer);
        }
      } else {
        this.infiniteScrollObserver?.disconnect();
        this.infiniteScrollObserver = null;
        this.infiniteScrollController?.destroy();
        this.infiniteScrollController = null;
      }
    };

    handleInfiniteScrollResize = () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(this.updateInfiniteScroll, 200);
    };

    restartInfiniteScroll = () => {
      this.infiniteScrollObserver?.disconnect();
      this.infiniteScrollObserver = null;
      this.infiniteScrollController?.destroy();
      this.infiniteScrollController = null;
      this.updateInfiniteScroll();
    };
  }

  if (!customElements.get('search-results-loader')) {
    customElements.define('search-results-loader', SearchResultsLoader);
  }

  } catch(e) { console.error(e); }
})();
})();
